import { Link } from "react-router-dom";
import { CaretRight, House } from "@phosphor-icons/react";

export default function AppBreadcrumbs({ items = [], className = "" }) {
  const trail = [
    { label: "Dashboard", to: "/", icon: House },
    ...items.filter((item) => item?.label),
  ];

  return (
    <nav
      className={`app-breadcrumbs${className ? ` ${className}` : ""}`}
      aria-label="Breadcrumb"
    >
      <ol>
        {trail.map((item, index) => {
          const isCurrent = index === trail.length - 1;
          const Icon = item.icon;

          return (
            <li key={`${item.to || "current"}-${item.label}`}>
              {index > 0 && (
                <CaretRight
                  size={12}
                  weight="bold"
                  className="app-breadcrumbs__separator"
                  aria-hidden="true"
                />
              )}

              {item.to && !isCurrent ? (
                <Link
                  to={item.to}
                  state={item.state}
                  className="app-breadcrumbs__link"
                >
                  {Icon && <Icon size={14} weight="duotone" aria-hidden="true" />}
                  <span>{item.label}</span>
                </Link>
              ) : (
                <span
                  className="app-breadcrumbs__current"
                  aria-current={isCurrent ? "page" : undefined}
                >
                  {Icon && <Icon size={14} weight="duotone" aria-hidden="true" />}
                  <span>{item.label}</span>
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
